@if (useMenu) {
  <a
    navigation-rail-item
    icon="menu"
    class="rail-menu"
    (click)="onItemClick($event, 'menu')"
    (keydown)="onItemKeyDown($event, 'menu')"
    aria-label="Menu"
    tabindex="-1"
    #menuButton
  ></a>
}

@if (useBack) {
  <div id="rail-back-btn">
    <a
      navigation-rail-item
      icon="cds-comp:arrow-back"
      class="rail-back"
      (click)="onItemClick($event, 'back')"
      (keydown)="onItemKeyDown($event, 'back')"
      [attr.aria-label]="backLabel"
      tabindex="-1"
      #backButton
    ></a>
    <dcr-plain-tooltip
      anchor="rail-back-btn"
      [label]="backLabel"
      positioning="popover"
      anchor-corner="start-end"
      surface-corner="end-start"
    ></dcr-plain-tooltip>
  </div>
}

@if (fabIcon) {
  <button
    fab-button
    [attr.aria-label]="fabLabel"
    [icon]="fabIcon"
    (click)="onItemClick($event, 'fab')"
    (keydown)="onItemKeyDown($event, 'fab')"
    tabindex="-1"
    #fabButton
  ></button>
}

<div
  #itemsContainer
  class="[ stack flex-1 ] [ p-b-s ]"
  [ngClass]="{
    'justify-start': align === 'top',
    'justify-center': align === 'center',
    'justify-end': align === 'bottom',
  }"
  >
  @for (item of items; track trackByLabel($index, item)) {
    <a
      navigation-rail-item
      [icon]="item.icon"
      [label]="item.label"
      [selected]="item.selected"
      [badge]="item.badge"
      (mousedown)="onItemClick($event, item)"
      (keydown)="onItemKeyDown($event, item)"
      [attr.tabindex]="item.selected ? 0 : -1"
      (focusin)="item.active && onActiveItemFocus($event, item)"
      [routerLink]="item.routerLink"
      [queryParams]="item.routerOptions?.queryParams"
      [fragment]="item.routerOptions?.fragment"
      [queryParamsHandling]="item.routerOptions?.queryParamsHandling"
      [preserveFragment]="item.routerOptions?.preserveFragment"
      [skipLocationChange]="item.routerOptions?.skipLocationChange"
      [replaceUrl]="item.routerOptions?.replaceUrl"
      [state]="item.routerOptions?.state"
      [relativeTo]="item.routerOptions?.relativeTo"
    ></a>
  }
</div>
